import "./styles.css";
import Aktualnosci from "../pages/Aktualnosci/Aktualnosci";
import Regulamin from "../pages/Regulamin/Regulamin";
import Contact from "../pages/Contact/Contact";
import Content from "../components/Content/Content";
import { Route, Routes } from "react-router-dom";
import Polityka from "../pages/Polityka/Polityka";
import DeklaracjaDostepnosci from "../pages/DeklaracjaDostepnosci/DeklaracjaDostepnosci";
import PageNot from "../pages/PageNot/PageNot";
import Hackathon from "../pages/Hackathon/Hackathon";

interface ContentProps {
}

const RouteContent: React.FC<ContentProps> = ({}) => {
  return (
    <Routes>
      <Route path="/" element={<Content />} />
      <Route path="/regulamin" element={<Regulamin />} />
      <Route path="/aktualnosci" element={<Aktualnosci />} />
      <Route path="/hackathon" element={<Hackathon />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/polityka" element={<Polityka />} />
      <Route path="/deklaracja-dostepnosci" element={<DeklaracjaDostepnosci />} />
      <Route
        path="/*"
        element={<PageNot />}/>
    </Routes>
  );
};
export default RouteContent;
